(() => {
  const cards = [...document.querySelectorAll('.hk-collab')];
  const filters = [...document.querySelectorAll('[data-filter]')];
  const search = document.getElementById('hk-search');
  const more = document.getElementById('hk-more');
  let filter = 'all', expanded = false;
  const normalize = value => value.normalize('NFKC').toLowerCase().replace(/\s/g,'');
  function showCards() {
    const q = normalize(search?.value || '');
    const matched = cards.filter(card => (filter === 'all' || card.dataset.status === filter) && (!q || normalize(card.dataset.name).includes(q)));
    const shown = (expanded || q || filter !== 'all') ? matched : matched.slice(0,8);
    cards.forEach(card => { card.hidden = !shown.includes(card); });
    document.getElementById('hk-empty').hidden = matched.length !== 0;
    document.getElementById('hk-result').textContent = `${matched.length}枠中 ${shown.length}枠を表示`;
    more.hidden = shown.length >= matched.length;
  }
  filters.forEach(button => button.addEventListener('click', () => {
    filter = button.dataset.filter;
    filters.forEach(b => b.setAttribute('aria-pressed',String(b === button)));
    showCards();
  }));
  search?.addEventListener('input',showCards);
  more?.addEventListener('click',()=>{expanded=true;showCards();});
  document.querySelectorAll('[data-set]').forEach(button => {
    button.addEventListener('click',()=>{
      document.querySelectorAll('[data-set]').forEach(b=>b.setAttribute('aria-selected',String(b===button)));
      document.getElementById('hk-panel-a').hidden = button.dataset.set !== 'a';
      document.getElementById('hk-panel-b').hidden = button.dataset.set !== 'b';
    });
    button.addEventListener('keydown',event=>{
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        const next = document.querySelector(`[data-set="${button.dataset.set === 'a' ? 'b' : 'a'}"]`);
        next.focus(); next.click();
      }
    });
  });
  const dialog=document.getElementById('hk-image-dialog');
  document.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{
    const source=button.querySelector('img');
    dialog.querySelector('img').src=source.src;
    dialog.querySelector('img').alt=source.alt;
    dialog.querySelector('p').textContent=source.alt;
    dialog.showModal();
  }));
  dialog?.querySelector('[data-close-image]').addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
})();
